// Generated by ReScript, PLEASE EDIT WITH CARE

import * as City from "../../domain/types/vehicle-specific/City.bs.js";
import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "../../../../../node_modules/rescript/lib/es6/string.js";
import * as CityConfig from "../../domain/store/CityConfig.bs.js";
import * as BrowserUtils from "../../../../library/utils/BrowserUtils.bs.js";
import * as ContentTypes from "../../../../common/types/ContentTypes.bs.js";
import * as ContentHelper from "../../../../common/helper/ContentHelper.bs.js";
import * as CircularLoader from "../../../../common/components/loader/components/CircularLoader.bs.js";
import * as StickyComponent from "../../../../common/components/download-sticky/component/StickyComponent.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as TrackLiveTripConfig from "../../domain/store/TrackLiveTripConfig.bs.js";
import * as TrackLiveTripRepoManager from "../../domain/repo/TrackLiveTripRepoManager.bs.js";
import * as TrackLiveTripAssetsManager from "../assets/TrackLiveTripAssetsManager.bs.js";
import * as Lib$PorterinFusionkitSentry from "../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.bs.js";
import * as TrackLiveTripMarketingGoodsCmp from "./TrackLiveTripMarketingGoodsCmp.bs.js";
import * as TrackLiveTripMarketingModalCmp from "./TrackLiveTripMarketingModalCmp.bs.js";
import * as TrackLiveTripMarketingVMMapper from "../view-model/TrackLiveTripMarketingVMMapper.bs.js";
import * as TrackLiveTripMarketingVehiclesCmp from "./TrackLiveTripMarketingVehiclesCmp.bs.js";

function getSavingsRow(savingsMarketingContent) {
  return React.createElement("div", {
              className: "track-live-trip-marketing__savings"
            }, React.createElement("b", undefined, savingsMarketingContent.title), List.nth(savingsMarketingContent.text, 0), React.createElement("b", undefined, savingsMarketingContent.subtitle), List.nth(savingsMarketingContent.text, 1));
}

function getDownloadRow(downloadLinkContent, crn) {
  return React.createElement("div", {
              className: "track-live-trip-marketing__download",
              onClick: (function (param) {
                  return TrackLiveTripMarketingVMMapper.publishGAEvents("Clicked App Download", crn);
                })
            }, React.createElement("a", {
                  className: "track-live-trip-marketing__download-link",
                  href: downloadLinkContent.subtitle
                }, downloadLinkContent.title));
}

function getDiscountRow(discountMarketingContent) {
  return React.createElement("div", {
              className: "track-live-trip-marketing__discount"
            }, discountMarketingContent.title, React.createElement("b", undefined, discountMarketingContent.subtitle), List.nth(discountMarketingContent.text, 0), React.createElement("b", undefined, List.nth(discountMarketingContent.text, 1)), List.nth(discountMarketingContent.text, 2), React.createElement("b", undefined, List.nth(discountMarketingContent.text, 3)), List.nth(discountMarketingContent.text, 4));
}

function getTopContainer(marketingObj, crn) {
  var discountMarketingContent = marketingObj.discountMarketingContent;
  return React.createElement("div", {
              className: "track-live-trip-marketing__top-container"
            }, React.createElement("div", {
                  className: "track-live-trip-marketing__top-bar"
                }), getSavingsRow(marketingObj.savingsMarketingContent), getDownloadRow(marketingObj.downloadLinkContent, crn), discountMarketingContent !== undefined ? getDiscountRow(discountMarketingContent) : null);
}

function getMarketingContent(content) {
  return React.createElement("div", {
              className: "track-live-trip-marketing__marketing-content"
            }, React.createElement("div", {
                  className: "track-live-trip-marketing__marketing-title"
                }, content.title), React.createElement("div", {
                  className: "track-live-trip-marketing__marketing-subtitle"
                }, content.subtitle));
}

function getEtaRow(marketingObj) {
  return React.createElement("div", {
              className: "track-live-trip-marketing__row"
            }, React.createElement("div", {
                  className: "track-live-trip-marketing__eta-bullet"
                }), getMarketingContent(marketingObj.etaMarketingContent));
}

function getPriceRow(marketingObj) {
  return React.createElement("div", {
              className: "track-live-trip-marketing__row"
            }, React.createElement("div", {
                  className: "track-live-trip-marketing__price-bullet"
                }), getMarketingContent(marketingObj.priceMarketingContent));
}

function getPartnerRow(marketingObj) {
  return React.createElement("div", {
              className: "track-live-trip-marketing__row"
            }, React.createElement("div", {
                  className: "track-live-trip-marketing__partner-bullet"
                }), getMarketingContent(marketingObj.partnerMarketingContent));
}

function getBookingTimeRow(marketingObj) {
  return React.createElement("div", {
              className: "track-live-trip-marketing__row"
            }, React.createElement("div", {
                  className: "track-live-trip-marketing__booktime-bullet"
                }), getMarketingContent(marketingObj.bookingTimeMarketingContent));
}

function getBottomContainer(marketingObj) {
  return React.createElement("div", {
              className: "track-live-trip-marketing__bottom-container"
            }, React.createElement("div", {
                  className: "track-live-trip-marketing__title"
                }, marketingObj.marketingTitle), getEtaRow(marketingObj), getPriceRow(marketingObj), getPartnerRow(marketingObj), getBookingTimeRow(marketingObj));
}

function showMobileApps(param) {
  var isAndroid = BrowserUtils.useAndroidDetector(undefined);
  return React.createElement("div", {
              className: "track-live-trip-marketing__mobile-apps",
              id: "bottom-app-container"
            }, React.createElement("div", {
                  className: "title"
                }, TrackLiveTripConfig.download_app_text), React.createElement("div", {
                  className: "apps-list"
                }, isAndroid ? React.createElement("a", {
                        className: "app",
                        href: TrackLiveTripConfig.android_link,
                        onClick: (function (param) {
                            return TrackLiveTripMarketingVMMapper.publishGAEvents("Static Download Android", "");
                          })
                      }, React.createElement("img", {
                            className: "img",
                            alt: "android icon",
                            src: TrackLiveTripConfig.android_icon
                          })) : React.createElement("a", {
                        className: "app",
                        href: TrackLiveTripConfig.ios_link,
                        onClick: (function (param) {
                            return TrackLiveTripMarketingVMMapper.publishGAEvents("Static Download iOS", "");
                          })
                      }, React.createElement("img", {
                            className: "img",
                            alt: "ios icon",
                            src: TrackLiveTripConfig.ios_icon
                          }))));
}

function TrackLiveTripMarketingComponent(Props) {
  var marketingDetail = Props.marketingDetail;
  var crn = Props.crn;
  var geo_region_id = Props.geo_region_id;
  var RepoInstance = TrackLiveTripRepoManager.getTrackLiveTripRepo(undefined);
  var match = React.useState(function () {
        return /* Init */0;
      });
  var setAvailableVehicles = match[1];
  var availableVehicles = match[0];
  var marketingObj = TrackLiveTripMarketingVMMapper.getVM(marketingDetail);
  var sticky_download_link_with_action = {
    TAG: /* LinkTextWithAction */7,
    _0: {
      link_with_text: {
        text: ContentTypes.createTitle(marketingObj.downloadLinkContent.title),
        target: ContentTypes.createUrl(marketingObj.downloadLinkContent.subtitle)
      },
      action: (function (param) {
          return TrackLiveTripMarketingVMMapper.publishGAEvents("Sticky download", crn);
        })
    }
  };
  var download_offer_data = {
    TAG: /* LabelledImgWithDesc */6,
    _0: {
      src_path: ContentTypes.createAssetPath(TrackLiveTripAssetsManager.getTrackLiveTripsImage("price_tag.svg")),
      text: ContentTypes.createTitle(TrackLiveTripConfig.download_offer_text_prefix_newview),
      desc: TrackLiveTripConfig.download_offer_text_suffix,
      class_name: ""
    }
  };
  var match$1 = React.useState(function () {
        
      });
  var setGoodsList = match$1[1];
  var match$2 = React.useState(function () {
        
      });
  var setGoods = match$2[1];
  var match$3 = React.useState(function () {
        
      });
  var setVehicle = match$3[1];
  var match$4 = React.useState(function () {
        return false;
      });
  var setModal = match$4[1];
  var showModal = match$4[0];
  var modalHandler = function (flag) {
    return Curry._1(setModal, (function (param) {
                  return flag;
                }));
  };
  React.useEffect((function () {
          var vh = (window.innerHeight * 0.01).toString();
          document.documentElement.style.setProperty("--vh", vh + "px");
          ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._1(RepoInstance.getVehicleInfo, $$String.lowercase_ascii(City.geoRegionIdToCity(geo_region_id)) === CityConfig.delhi_NCR ? CityConfig.delhi : $$String.lowercase_ascii(City.geoRegionIdToCity(geo_region_id)));
                }), (function (data) {
                  var vehicle_data = TrackLiveTripMarketingVMMapper.getAvailableVehiclesInfo(data.vehicle);
                  Curry._1(setAvailableVehicles, (function (param) {
                          return {
                                  TAG: /* Live */1,
                                  _0: vehicle_data
                                };
                        }));
                  var useCasesList = TrackLiveTripMarketingVMMapper.getUsecasesList(vehicle_data);
                  Curry._1(setGoodsList, (function (param) {
                          return ContentHelper.getContentList(useCasesList);
                        }));
                  Curry._1(setVehicle, (function (param) {
                          return List.hd(vehicle_data);
                        }));
                  return Curry._1(setGoods, (function (param) {
                                return ContentHelper.getContent(List.hd(useCasesList));
                              }));
                }), (function (error) {
                  Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, ErrorUtils$Catalyst.resolveError(error));
                  
                }));
          
        }), []);
  React.useEffect((function () {
          setTimeout((function (param) {
                  if (!TrackLiveTripMarketingVMMapper.hideAppDownloadModal(geo_region_id)) {
                    Curry._1(setModal, (function (param) {
                            return true;
                          }));
                    return TrackLiveTripMarketingVMMapper.publishGAEvents(TrackLiveTripConfig.offer_modal_opened_label, crn);
                  }
                  
                }), TrackLiveTripMarketingVMMapper.getModalApperanceTime(undefined));
          
        }), []);
  var vehicleSelectHandler = function (vehicle_info) {
    var ele = document.getElementById("bottom-app-container");
    TrackLiveTripMarketingVMMapper.scrollToElement(ele);
    return Curry._1(setVehicle, (function (param) {
                  return vehicle_info;
                }));
  };
  var servicesDescHandler = function (category) {
    return Curry._1(setGoods, (function (param) {
                  return category;
                }));
  };
  var tmp;
  if (typeof availableVehicles === "number") {
    tmp = React.createElement(CircularLoader.make, {});
  } else if (availableVehicles.TAG === /* Live */1) {
    var available_vehicles = availableVehicles._0;
    tmp = React.createElement(React.Fragment, undefined, React.createElement(TrackLiveTripMarketingModalCmp.make, {
              show_modal: showModal,
              setModal: modalHandler,
              download_link: marketingObj.downloadLinkContent.subtitle,
              crn: crn
            }), React.createElement(TrackLiveTripMarketingVehiclesCmp.make, {
              available_vehicles: available_vehicles,
              selected_vehicle: match$3[0],
              vehicle_selector: vehicleSelectHandler
            }), React.createElement(TrackLiveTripMarketingGoodsCmp.make, {
              available_vehicles: available_vehicles,
              goods_list: match$1[0],
              selected_goods: match$2[0],
              services_handler: servicesDescHandler
            }));
  } else {
    tmp = React.createElement(CircularLoader.make, {});
  }
  return React.createElement("div", {
              className: "track-live-trip-marketing__container"
            }, tmp, showMobileApps(undefined), showModal ? null : React.createElement(StickyComponent.make, {
                    link_with_text_action: sticky_download_link_with_action,
                    offer_details_info: download_offer_data,
                    target: "bottom-app-container",
                    observerOption: {
                      rootMargin: "0px"
                    }
                  }));
}

var make = TrackLiveTripMarketingComponent;

export {
  getSavingsRow ,
  getDownloadRow ,
  getDiscountRow ,
  getTopContainer ,
  getMarketingContent ,
  getEtaRow ,
  getPriceRow ,
  getPartnerRow ,
  getBookingTimeRow ,
  getBottomContainer ,
  showMobileApps ,
  make ,
  
}
/* City Not a pure module */
